<template>
  <div class="modal fade" id="newProjectModal" tabindex="-1" role="dialog" aria-labelledby="newProjectModal" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">New Project</h5>
        </div>
        <div class="modal-body">
          <div>
            <div class="form-group row align-items-center">
              <div class="col">
                <input v-model="name" placeholder="Project Name" class="form-control">
              </div>
            </div>
            <ProjectAreaSelector ref="project_area_selector" />
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary" v-on:click="submit">Create Project</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from "api";
  import ProjectAreaSelector from 'ProjectAreaSelector';

  export default {
    components: {
      ProjectAreaSelector
    },
    data() {
      return {
        name: '',
        project_area_name: '',
        project_area_id: '',
      };
    },
    methods: {
      submit: function() {
        if(this.name && (typeof this.project_area_id == 'number' || this.project_area_name != '')){
          api.createProject({ name: this.name, project_area_id: this.project_area_id, project_area_name: this.project_area_name }).then(response => {
            this.name = '';
            this.project_area_id = '';
            this.project_area_name = '';
            this.$refs.project_area_selector.resetData()
            $('#newProjectModal').modal('hide')
          });
        }
      },
    }
  }
</script>
